/* Rhody Reviews api/v1 -- templates domain. PURE EXTRACTION from lib/api.ts (gate-prep split); no behavior change.
   Gallery methods (template-gallery + from-gallery) added 2026-06-29 (Brad) for the Browse-templates deep bench. */
import { request } from './_http';

/* Templates CRUD (GET/POST/PUT/DELETE /templates). */
export interface Template {
  id: string;
  name: string;
  channel: 'sms' | 'email';
  subject: string | null;
  body: string;
  is_default: boolean;
  status: string;
  sent_count: number;
  [k: string]: unknown;
}
export interface TemplatesResponse {
  client_id: string;
  count: number;
  templates: Template[];
}
export interface TemplateInput {
  name?: string;
  channel?: 'sms' | 'email';
  body?: string;
  subject?: string | null;
  is_default?: boolean;
  status?: string;
}

/* ----- Template gallery (the deep bench: ready-made templates across packs) -----
   GET  /api/v1/template-gallery        -> browse the catalog (optional pack/scenario/channel filters)
   POST /api/v1/templates/from-gallery  -> add one catalog item to the tenant's own list */
export type GalleryPack = 'trades' | 'real_estate' | 'general';
export type GalleryScenario =
  | 'after_job'
  | 'reminder_1'
  | 'reminder_2'
  | 'first_time'
  | 'repeat'
  | 'post_estimate'
  | 'win_back'
  | 'seasonal';
export interface GalleryTemplate {
  id: string;
  pack: GalleryPack | string;
  scenario: GalleryScenario | string;
  channel: 'sms' | 'email';
  name: string;
  subject: string | null;
  body: string;
  [k: string]: unknown;
}
export interface TemplateGalleryResponse {
  templates: GalleryTemplate[];
  packs: string[];
  scenarios: string[];
}
export interface GalleryQuery {
  pack?: GalleryPack | string;
  scenario?: GalleryScenario | string;
  channel?: 'sms' | 'email';
}

export const templatesApi = {
  /* ----- Template gallery ----- */
  listTemplateGallery(
    query?: GalleryQuery,
    signal?: AbortSignal,
  ): Promise<TemplateGalleryResponse> {
    return request<TemplateGalleryResponse>('/api/v1/template-gallery', {
      query: query as Record<string, string | undefined> | undefined,
      signal,
    });
  },
  addTemplateFromGallery(
    galleryId: string,
  ): Promise<{ client_id: string; template: Template }> {
    return request<{ client_id: string; template: Template }>(
      '/api/v1/templates/from-gallery',
      { method: 'POST', body: { gallery_id: galleryId } },
    );
  },

  /* ----- Templates CRUD ----- */
  listTemplates(signal?: AbortSignal): Promise<TemplatesResponse> {
    return request<TemplatesResponse>('/api/v1/templates', { signal });
  },
  createTemplate(input: TemplateInput): Promise<{ client_id: string; template: Template }> {
    return request<{ client_id: string; template: Template }>('/api/v1/templates', {
      method: 'POST',
      body: input,
    });
  },
  updateTemplate(
    id: string,
    patch: TemplateInput,
  ): Promise<{ client_id: string; template: Template }> {
    return request<{ client_id: string; template: Template }>(
      `/api/v1/templates/${encodeURIComponent(id)}`,
      { method: 'PUT', body: patch },
    );
  },
  deleteTemplate(id: string): Promise<{ client_id: string; deleted: string }> {
    return request<{ client_id: string; deleted: string }>(
      `/api/v1/templates/${encodeURIComponent(id)}`,
      { method: 'DELETE' },
    );
  },
};
